import { render, staticRenderFns } from "./RirekishoRecommendCard.vue?vue&type=template&id=7a5971b6"
import script from "./RirekishoRecommendCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoRecommendCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports